import {
  LogoAnsible,
  LogoCloudFormationColored,
  LogoKubernetesColored,
  LogoOpentofuColored,
  LogoPulumiColored,
  LogoTerraformColored,
  LogoTerragruntColored,
} from "components/icons/generated";
import { IconComponent } from "types/Icon";

import { StackCreationVendor } from "../types";

type VendorTile = {
  type: StackCreationVendor;
  name: string;
  logos: IconComponent[];
  isNew?: boolean;
};

const pulumiTile: VendorTile = {
  type: StackCreationVendor.Pulumi,
  name: "Pulumi",
  logos: [LogoPulumiColored],
};

const cloudFormationTile: VendorTile = {
  type: StackCreationVendor.CloudFormation,
  name: "CloudFormation",
  logos: [LogoCloudFormationColored],
};

const kubernetesTile: VendorTile = {
  type: StackCreationVendor.Kubernetes,
  name: "Kubernetes",
  logos: [LogoKubernetesColored],
};

const terragruntTile: VendorTile = {
  type: StackCreationVendor.Terragrunt,
  name: "Terragrunt",
  logos: [LogoTerragruntColored],
};

const ansibleTile: VendorTile = {
  type: StackCreationVendor.Ansible,
  name: "Ansible",
  logos: [LogoAnsible],
};

export const vendorConfig: VendorTile[] = [
  {
    type: StackCreationVendor.Terraform,
    name: "OpenTofu / Terraform",
    logos: [LogoOpentofuColored, LogoTerraformColored],
  },
  pulumiTile,
  cloudFormationTile,
  kubernetesTile,
  terragruntTile,
  ansibleTile,
];

export const vendorConfigWithOpenTofu: VendorTile[] = [
  {
    type: StackCreationVendor.OpenTofu,
    name: "OpenTofu",
    logos: [LogoOpentofuColored],
    isNew: true,
  },
  pulumiTile,
  cloudFormationTile,
  kubernetesTile,
  terragruntTile,
  ansibleTile,
  {
    type: StackCreationVendor.Terraform,
    name: "Terraform",
    logos: [LogoTerraformColored],
  },
];
